export default {
  project: {},
  projects: [],
  isMatchCurrentProject: true,
  region: {},
  regions: [],
  loading: false,
  dashboard: {},
  dashboards: {},
  dashboardActiveTab: 'my',
  dashboardActiveMenu: '',
  widgetRefresh: false,
  productSubTypesY: [],
  productSubTypesN: [],
  agentProductTypes: [],
  iconProductType: '',
  params: {}
};
